export enum EditableForm {
  PersonalData = 'personal-data',
  Password = 'password',
  Phone = 'phone',
  Company = 'company',
}
